import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { SplitText } from "gsap/SplitText";
// import { PinPlugin } from "gsap/PinPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, SplitText);

/* Home */
export function heroIntro(deviceData, cookies) {

  if (cookies.checkCookie('once') === 'true' || deviceData.isMobile === true) {
    return;
  }

  /* Tenemos una clase "videoback-loading" en el body que debemos quitar a los 6 segundos de cargado el dom */
  setTimeout(() => {
    document.body.classList.remove('videoback-loading');
  }, 6000);

  const tl = gsap.timeline({
    ease: "power4.inOut",
    scrollTrigger: {
      trigger: ".logo",
      scrub: 6,
      start: "top top",
      end: "75% top",
      // markers: true,
    },
  });

  gsap.set("#logo_intro", {
    opacity: 1,
  });

  const logoIntro = tl
    .fromTo("#logo_intro",
      { translateY: "900vh" },
      { translateY: "0" })
    .fromTo("#roof_1",
      { scale: 200, },
      { scale: 1 }, "<")
    .fromTo("#roof_2",
      { scale: 200, },
      { scale: 1 }, "-=0.45")
    .fromTo("#roof_3",
      { scale: 200, },
      { scale: 1 }, "-=0.45")
    .fromTo("#roof_4",
      { scale: 200, },
      { scale: 1 }, "-=0.45")
    .fromTo("#silent_room",
      { scale: 200, },
      { scale: 1 }, "-=0.45");

  return logoIntro;

}

export function logoOutro(deviceData, cookies) {

  if (cookies.checkCookie('once') === 'true' || deviceData.isMobile === true) {
    return;
  }

  const tl = gsap.timeline({
    ease: "power4.inOut",
    scrollTrigger: {
      trigger: ".logo",
      scrub: 5,
      start: "100% top",
      end: "75% top",
      // markers: true,
    },
  });

  const logoOutro = tl
    .fromTo("#studio",
      { translateY: "1rem" },
      { translateY: "0" })
    .fromTo("#studio path",
      { clipPath: "polygon(0 0, 100% 0, 100% 0, 0 0)" },
      { clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)" }, "<")
    .to("#logo_intro", {
      opacity: 0,
    }, "+=0.5");

  return logoOutro;

}

export function homeAutoScroll(deviceData, cookies) {

  if (cookies.checkCookie('once') === 'true' || deviceData.isMobile === true) {
    return;
  }

  let initialScrollDone = false;

  const preventScroll = (e) => {
    e.preventDefault();
  };

  const disableUserScroll = () => {
    document.body.style.overflow = 'hidden';
    window.addEventListener('wheel', preventScroll, { passive: false });
    window.addEventListener('touchmove', preventScroll, { passive: false });
  };

  const enableUserScroll = () => {
    document.body.style.overflow = '';
    window.removeEventListener('wheel', preventScroll, { passive: false });
    window.removeEventListener('touchmove', preventScroll, { passive: false });
  };

  window.addEventListener('load', () => {
    if (window.lenis && !initialScrollDone) {
      initialScrollDone = true;
      disableUserScroll(); // Deshabilitamos el scroll del usuario
      window.lenis.scrollTo(window.innerHeight, {
        duration: 4.5,
        ease: 'power4.inOut',
        onComplete: () => {
          // Una vez que el primer scroll termina, ejecutamos el segundo
          setTimeout(() => {
            window.lenis.scrollTo(window.lenis.scroll + window.innerHeight * 1.7, {
              duration: 4,
              ease: 'power4.inOut',
              onComplete: () => {
                setTimeout(() => {
                  enableUserScroll(); // Rehabilitamos el scroll al final
                }, 2000);
              }
            });
          }, 700);
        }
      });
    }
  });

}

export function homeScreenElements(deviceData) {

  const logo = document.querySelector('.logo');

  if (deviceData.isDesktop !== true || logo === null) {
    return;
  }

  const tl = gsap.timeline({
    ease: "power4.inOut",
    scrollTrigger: {
      trigger: ".logo",
      scrub: 6,
      start: "125% top", // Inicia cuando la primera animación está a medio camino
      end: "75% top",
      // markers: true,
    },
  });

  const screenElements = tl
    .to("header .brand",
      { clipPath: "polygon(0 100%, 100% 100%, 100% 0, 0 0)" }, "+=0.1")
    .to("header .brand img",
      { translateY: 0 },
      "<")
    .to("header .anim-box span",
      {
        stagger: 0.15,
        translateY: 0
      },
      "<")
    .to(".sidebar-left .anim-box span",
      {
        stagger: 0.15,
        translateY: 0
      },
      "<")
    .to(".sidebar-right .anim-box span",
      {
        stagger: 0.15,
        translateY: 0
      },
      "<");

  return screenElements;

}

export function snapScroll(deviceData) {

  if (deviceData.isDesktop !== true) {
    return;
  }

  ScrollTrigger.matchMedia({
    // Se aplica a todos los tamaños de pantalla
    "(min-width: 1px)": function () {
      // Seleccionar todas las secciones dentro del contenedor snap
      const sections = document.querySelectorAll('.container-snap section');

      if (!sections.length) return;

      let triggers = [];
      let allTitleSplits = [];

      // Bandera para detectar si el scroll es por la rueda del mouse
      let isWheeling = false;
      let wheelTimeout;
      const wheelListener = () => {
        isWheeling = true;
        clearTimeout(wheelTimeout);
        wheelTimeout = setTimeout(() => {
          isWheeling = false;
        }, 750); // Mantener activo por 750ms
      };
      window.addEventListener('wheel', wheelListener);

      // Función para resetear los estilos de una sección
      function resetSectionStyles(section) {
        const clipIntro = section.querySelectorAll('.clip-intro');

        // Solo proceder si hay elementos para animar
        if (clipIntro.length > 0) {
          // Detener cualquier animación en curso y limpiar todas las propiedades
          gsap.killTweensOf(clipIntro);
          gsap.to(clipIntro, {
            clearProps: "all",
            duration: 0
          });

          // Volver a establecer los estilos iniciales
          gsap.set(clipIntro, {
            clipPath: 'polygon(0 0, 100% 0, 100% 0, 0 0)',
            opacity: 0,
            translateY: "1rem",
          });
        }
      }

      // Esperar a que las fuentes estén cargadas
      document.fonts.ready.then(function () {
        sections.forEach((section, i) => {
          // Obtener los elementos .clip-intro dentro de esta sección
          const clipIntro = section.querySelectorAll('.clip-intro');
          const titles = section.querySelectorAll('.title > span');

          // Crear un array para almacenar las instancias de SplitText
          const titleSplits = [];

          // Aplicar SplitText a cada título si existen
          if (titles.length > 0) {
            titles.forEach(title => {
              try {
                const split = SplitText.create(title, { type: "chars" });
                titleSplits.push(split);
                allTitleSplits.push(split); // Guardar para la limpieza

                // Hacemos visible el título padre una vez que el texto está dividido
                gsap.to(title.closest('.title'), { opacity: 1 });
              } catch (error) {
                console.warn("Error al crear SplitText:", error);
              }
            });
          }

          // Configurar las animaciones para los elementos .clip-intro solo si existen
          if (clipIntro.length > 0) {
            gsap.set(clipIntro, {
              clipPath: 'polygon(0 0, 100% 0, 100% 0, 0 0)',
              opacity: 0,
              translateY: "2rem",
            });
          }
          

          const st = ScrollTrigger.create({
            trigger: section,
            start: "top bottom-=100", // Ajustado para iniciar un poco antes
            end: "bottom top+=100",   // Ajustado para terminar un poco después
            onEnter: () => {
              // Resetear estilos antes de animar
              resetSectionStyles(section);

              // Navegar a la sección
              goToSection(i);

              // Actualizar el menú
              updateMenuState(section.dataset.section);

              // Animar la entrada de los elementos .clip-intro si existen
              if (clipIntro.length > 0) {
                gsap.to(clipIntro, {
                  clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
                  opacity: 1,
                  translateY: "0",
                  duration: 1,
                  stagger: 0.3, // Stagger de 0.5s entre elementos como indica la memoria
                  delay: 0.3,
                  ease: "power4.out"
                });
              }

              // Animar todos los títulos si existen
              if (titleSplits.length > 0) {
                titleSplits.forEach(split => {
                  gsap.fromTo(split.chars, {
                    transform: "translateY(100%)",
                    autoAlpha: 0,
                    stagger: 0.05,
                  }, {
                    transform: "translateY(0)",
                    autoAlpha: 1,
                    stagger: 0.05,
                    delay: 0.5, // <-- Esta es la forma correcta de agregar el retardo
                  });
                });
              }
            },
            onLeave: () => {
              // Resetear estilos antes de animar
              resetSectionStyles(section);

              // Animar la salida de los elementos cuando la sección sale por abajo
              if (clipIntro.length > 0) {
                gsap.to(clipIntro, {
                  clipPath: 'polygon(0 100%, 100% 100%, 100% 100%, 0 100%)',
                  opacity: 0,
                  translateY: "1rem",
                  duration: 0.6,
                  stagger: 0.2,
                  ease: "power4.in"
                });
              }

              // Animar todos los títulos si existen
              if (titleSplits.length > 0) {
                titleSplits.forEach(split => {
                  gsap.fromTo(split.chars, {
                    transform: "translateY(100%)",
                    autoAlpha: 0,
                    stagger: 0.05,
                  }, {
                    transform: "translateY(0)",
                    autoAlpha: 1,
                    stagger: 0.05,
                  });
                });
              }
            },
            onEnterBack: () => {
              // Resetear estilos antes de animar
              resetSectionStyles(section);

              // Navegar a la sección
              goToSection(i);

              // Actualizar el menú
              updateMenuState(section.dataset.section);

              // Animar la entrada cuando volvemos a la sección desde abajo
              if (clipIntro.length > 0) {
                gsap.to(clipIntro, {
                  clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
                  opacity: 1,
                  translateY: "0",
                  duration: 1,
                  stagger: 0.5,
                  delay: 0.5,
                  ease: "power4.out"
                });
              }

              // Animar todos los títulos si existen
              if (titleSplits.length > 0) {
                titleSplits.forEach(split => {
                  gsap.fromTo(split.chars, {
                    transform: "translateY(100%)",
                    autoAlpha: 0,
                    stagger: 0.05,
                  }, {
                    transform: "translateY(0)",
                    autoAlpha: 1,
                    stagger: 0.05,
                  });
                });
              }
            },
            onLeaveBack: () => {
              // Resetear estilos antes de animar
              resetSectionStyles(section);

              // Animar la salida cuando la sección sale por arriba
              if (clipIntro.length > 0) {
                gsap.to(clipIntro, {
                  clipPath: 'polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)',
                  opacity: 0,
                  translateY: "2rem",
                  duration: 0.6,
                  stagger: 0.2,
                  ease: "power4.in"
                });
              }
            },
            markers: false // Cambiar a true para debugging
          });
          triggers.push(st);
        });

        // Función para navegar a una sección específica
        function goToSection(index) {

          if (!isWheeling) return; // Esto es clave para que funcionen las anlcas (.anchor)
          // Notificar a Lenis que vamos a hacer un scroll programático
          if (window.lenis) {
            window.lenis.stop();
          }

          // Añadir data-section al body con el ID de la sección
          if (sections[index] && sections[index].id) {
            document.body.setAttribute('data-section', sections[index].id);
          }

          gsap.to(window, {
            scrollTo: {
              y: sections[index],
              autoKill: false
            },
            duration: 1,
            ease: "power4.out",
            onComplete: () => {
              // Reactivar Lenis después de la animación
              if (window.lenis) {
                window.lenis.start();
              }

            }
          });

        }

        // Función para actualizar el estado del menú
        function updateMenuState(sectionId) {
          // Si no se proporciona un ID de sección, no hacer nada.
          if (!sectionId) return;

          const menuItems = document.querySelectorAll('.m-item');
          menuItems.forEach(item => {
            // Limpiar el href para que coincida con el ID de la sección (ej. '#works' -> 'works')
            const targetId = item.getAttribute('href').substring(1);
            if (targetId === sectionId) {
              item.classList.add('active');
            } else {
              item.classList.remove('active');
            }
          });
        }

        // Función de limpieza que se ejecuta cuando el media query ya no coincide
        return () => {
          window.removeEventListener('wheel', wheelListener);
          triggers.forEach(trigger => trigger.kill());
          allTitleSplits.forEach(split => split.revert());
          gsap.set(document.querySelectorAll('.clip-intro'), { clearProps: "all" });
        };
      });
    }
  });

}

export function titleIn() {

  document.fonts.ready.then(function () {

    const titles = document.querySelectorAll('.title > span');

    try {
      titles.forEach(title => { 
        const split = SplitText.create(title, { type: "chars" });


        gsap.to(title.closest('.title'), { opacity: 1 });

        gsap.fromTo(split.chars, {
          transform: "translateY(100%)",
          autoAlpha: 0,
          stagger: 0.05,
        }, {
          transform: "translateY(0)",
          autoAlpha: 1,
          stagger: 0.05,
          delay: 0.3
        });
      }, "+=0.2");

    } catch (error) {
      console.warn("Error al crear SplitText:", error);
    }

  });

}


export function tableRow(deviceData) {

  if (deviceData.isMobile === true) {
    return;
  }

  const tableRows = document.querySelectorAll('.table-row');
  const firstTenRows = Array.from(tableRows).slice(0, 10);

    gsap.to(firstTenRows, {
      transform: "translateY(0)",
      opacity: 1,
      stagger: 0.1
    })

}
